import {getIsFeatureFlagEnabled} from 'src/lib/experimentation/useIsFeatureFlagEnabled'

export const getIsAppRevampFunctionalUpdatesEnabled = (): boolean => {
  return getIsFeatureFlagEnabled('app-revamp-functional-updates')
}
